(function () {
  var sectionSelector = '.amigui-novedades-section article[data-product-handle], .amigui-seccion-curada-section article[data-product-handle]';
  var restoreKey = 'amigui-home-reloaded';

  function sectionCards() {
    return Array.prototype.slice.call(document.querySelectorAll(sectionSelector));
  }

  function removeCards(handle) {
    sectionCards().forEach(function (card) {
      if (card.getAttribute('data-product-handle') === handle) {
        card.remove();
      }
    });
  }

  function removeUnavailableCards() {
    var started = Object.create(null);

    sectionCards().forEach(function (card) {
      var handle = card.getAttribute('data-product-handle');
      if (!handle || started[handle]) {
        return;
      }
      started[handle] = true;

      fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (response.status === 404) {
          return { available: false };
        }
        if (!response.ok) {
          return null;
        }
        return response.json();
      }).then(function (product) {
        if (!product || product.available !== false) {
          return;
        }
        removeCards(handle);
      }).catch(function () {});
    });
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) {
      return;
    }

    try {
      if (sessionStorage.getItem(restoreKey) === '1') {
        sessionStorage.removeItem(restoreKey);
        document.documentElement.classList.remove('amigui-home-refreshing');
        removeUnavailableCards();
        return;
      }
      sessionStorage.setItem(restoreKey, '1');
    } catch (error) {
      removeUnavailableCards();
      return;
    }

    document.documentElement.classList.add('amigui-home-refreshing');
    setTimeout(function () { location.reload(); }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeUnavailableCards);
  } else {
    removeUnavailableCards();
  }
})();
